module.exports = __webpack_public_path__ + "4a4e4422b0267cc749448f0d946de84e.jpg";